import { cloneDeep } from "lodash-es"

// 批量将string类型的字段转换为number类型，这在给后端传递参数的时候有用
export function convertStringFiledToNumber<T extends object>(
  obj: T,
  keys: (keyof T)[],
) {
  const newObj: any = cloneDeep(obj)

  keys.forEach((key) => {
    const value = newObj[key]

    if (value && typeof value === "string") {
      newObj[key] = Number(value)
    }
  })
  return newObj
}

// 检测字符串是否为0，
export const checkStr0Rule = {
  validator(_, value) {
    if (value === "0") {
      return "Required"
    }
  },
}

// 手动触发窗口resize事件
export function doResize() {
  setTimeout(function () {
    // 手动触发窗口resize事件
    if (document.createEvent) {
      const event = document.createEvent("HTMLEvents")
      event.initEvent("resize", true, true)
      window.dispatchEvent(event)
    }
  }, 10)
}

export function isUpgrade(
  subscribeInfo?: {
    period: number
    kind: number
    quota: number
  },
  current?: {
    period: number
    kind: number
    quota: number
  },
) {
  if (!subscribeInfo || !current) return true
  // 如果是月费到年费，视为升级
  if (subscribeInfo.period === 1 && current.period === 2) {
    return true
  }
  // 如果年费到月费高级以上，视为升级
  if (
    subscribeInfo.period === 2 &&
    current.period === 1 &&
    current.kind >= subscribeInfo.kind
  ) {
    return true
  }

  // 先比kind，kind大的为升级
  if (current.kind > subscribeInfo.kind) {
    return true
  }

  // 如果kind相等
  if (current.kind === subscribeInfo.kind) {
    // 则比quota，quota大的为升级
    if (current.quota > subscribeInfo.quota) {
      return true
    }
  }
  // 其他全部为降级或者平级
  return false
}

/**
 * 获取枚举的所有值（支持常规/字符串/数字 Enum）
 * @param enumObj TypeScript 枚举对象
 * @returns 枚举的所有值（去重，排除反向 key）
 */
export function getEnumValues<T extends Record<string, any>>(
  enumObj: T,
): Array<T[keyof T]> {
  // 如果是字符串枚举，Object.values 即可
  // 如果是数字枚举，Object.values 会包含 key=>value 和 value=>key 的反射部分，需要过滤
  const values = Object.values(enumObj)
  if (values.length === 0) return []

  // 检查是否为数字枚举 (自动反向映射)
  const isNumericEnum = values.some((v) => typeof v === "number")
  if (!isNumericEnum) {
    // 普通对象/字符串枚举
    return values as Array<T[keyof T]>
  }
  // 数字枚举，需要过滤出 number 类型的
  return values.filter((v) => typeof v !== "string") as Array<T[keyof T]>
}
